import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { getAuthorizedDrawers } from 'features/fuelManagement/fuelCustodySlice'
import { Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { IFuelAuthorizedDrawerGroup } from 'types/fuelOps.interface'
import { DRAWER_CLASS_TO_UI } from 'pages/FuelManagement/Shared/fuelEnumMaps'
import { formatDateForDisplay } from 'utils/helpers'
import { RootState } from 'store'
import { FUEL_AUTHORIZED_DRAWERS_CAPTION } from 'pages/FuelManagement/Shared/fuelFormatters'
import {
    DrawerChip,
    DrawerChips,
    DrawerClassName,
    DrawerGroupRow,
    DrawerMeta,
} from './AuthorizedDrawersPanel.styled'

export const AuthorizedDrawersPanel = () => {
    const dispatch = useDispatch()
    const { authorizedDrawers } = useSelector((store: RootState) => store.fuelCustody)

    useEffect(() => {
        dispatch(getAuthorizedDrawers() as any)
    }, [dispatch])

    const groups: IFuelAuthorizedDrawerGroup[] = authorizedDrawers.map((g) => ({
        machineClass: DRAWER_CLASS_TO_UI[g.machineClass] || String(g.machineClass),
        drawers: g.drawers.map((d) => d.name),
        updatedLabel: g.updatedAt
            ? `${g.updatedBy || '—'} · ${formatDateForDisplay(g.updatedAt, true)}`
            : 'Not configured',
    }))

    return (
        <Container>
            <ContainerHeader>
                <Flex center gap='0.75rem'>
                    <TitleText>Authorized drawers</TitleText>
                </Flex>
            </ContainerHeader>
            <ContainerContent>
                <OtherText grey>{FUEL_AUTHORIZED_DRAWERS_CAPTION}</OtherText>
                {!groups.length ? (
                    <Flex mt='8'>
                        <OtherText grey>Authorized drawer lists appear once fuel custody roles are connected.</OtherText>
                    </Flex>
                ) : (
                    groups.map((group) => (
                        <DrawerGroupRow key={group.machineClass}>
                            <DrawerClassName>{group.machineClass}</DrawerClassName>
                            <DrawerChips>
                                {group.drawers.map((drawer) => (
                                    <DrawerChip key={drawer}>{drawer}</DrawerChip>
                                ))}
                            </DrawerChips>
                            <DrawerMeta>{group.updatedLabel}</DrawerMeta>
                        </DrawerGroupRow>
                    ))
                )}
            </ContainerContent>
        </Container>
    )
}
